import React from "react";

const CanvasHeader = () => {
  return (
    <div className="canvas__header d--flex justify-space-between align-center">
      <div className="canvas__header--leftSection d--flex align-center">
        <div className="school--logo"></div>
        <div className="canvas__dropdownWrapper">
          <div className="canvas__dropdownSelect">
            <span>Lesson name</span>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.52729 6.69526C3.78764 6.43491 4.20975 6.43491 4.4701 6.69526L7.9987 10.2239L11.5273 6.69526C11.7876 6.43491 12.2098 6.43491 12.4701 6.69526C12.7305 6.95561 12.7305 7.37772 12.4701 7.63807L8.4701 11.6381C8.20975 11.8984 7.78764 11.8984 7.52729 11.6381L3.52729 7.63807C3.26694 7.37772 3.26694 6.95561 3.52729 6.69526Z"
                fill="#141414"
              />
            </svg>
          </div>
        </div>
        <div className="canvas__sections d--flex align-center">
          <div className="canvas__sections-prevBtn">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L9.41421 12L14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289Z"
                fill="#F4F4F4"
              />
            </svg>
          </div>
          <div className="canvas__sections--active d--flex justify-space-between align-center">
            <span>Building klen</span>
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.6644 8.75259C17.0771 9.11951 17.1143 9.75158 16.7474 10.1644L11.4141 16.1644C11.2243 16.3779 10.9523 16.5 10.6667 16.5C10.381 16.5 10.109 16.3779 9.91926 16.1644L7.25259 13.1644C6.88567 12.7516 6.92285 12.1195 7.33564 11.7526C7.74842 11.3857 8.38049 11.4229 8.74741 11.8356L10.6667 13.9948L15.2526 8.83564C15.6195 8.42285 16.2516 8.38567 16.6644 8.75259Z"
                  fill="#DCDCDC"
                />
              </svg>
            </span>
          </div>
          <div className="canvas__section--add">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 12H4"
                stroke="#C3C3C3"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M12 4V20"
                stroke="#C3C3C3"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div className="canvas__sections-nextBtn">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.7071C8.90237 6.31658 8.90237 5.68341 9.29289 5.29289C9.68342 4.90236 10.3166 4.90236 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071Z"
                fill="#F4F4F4"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="canvas__header--rightSection d-flex">
        <button className="canvas__header--playButton">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6.74129C6 5.19771 7.67443 4.23597 9.00774 5.01374L18.0231 10.2727C19.3461 11.0445 19.3461 12.9561 18.0231 13.7278L9.00774 18.9868C7.67443 19.7645 6 18.8028 6 17.2592V6.74129ZM17.0154 12.0003L8 6.74129V17.2592L17.0154 12.0003Z"
              fill="#0D0D0D"
            />
          </svg>
          Present mode
        </button>
        <button className="canvas__header--shareButton">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.5 12C20.5 12.7222 20.4099 13.4234 20.2404 14.0929C20.1442 14.102 20.0372 14.1119 19.9205 14.1226C19.3617 14.1739 18.5804 14.2423 17.6911 14.3107C17.1149 14.355 16.4953 14.3991 15.863 14.4385C16.0112 13.7206 16.0947 12.9862 16.0821 12.2564C16.0715 11.6493 15.9939 11.0157 15.8702 10.3774C16.5449 10.3334 17.2034 10.2839 17.8097 10.2346C18.7081 10.1615 19.4971 10.0885 20.0616 10.0337L20.2666 10.0136C20.4192 10.6509 20.5 11.316 20.5 12ZM14.3574 10.4635C14.4908 11.0988 14.5724 11.7132 14.5823 12.2824C14.5951 13.0226 14.4887 13.7804 14.3072 14.5232C13.497 14.5601 12.7066 14.5833 12 14.5833C11.2933 14.5833 10.5029 14.5601 9.69278 14.5232C9.51123 13.7804 9.40486 13.0226 9.41768 12.2824C9.42754 11.7132 9.50916 11.0988 9.64261 10.4635C10.4656 10.5029 11.2729 10.5278 12 10.5278C12.727 10.5278 13.5343 10.5029 14.3574 10.4635ZM15.5097 8.89729C16.2626 8.85026 17.0057 8.79503 17.6881 8.73953C18.5031 8.67325 19.2274 8.60697 19.7727 8.55461C18.6237 5.96617 16.2195 4.05847 13.3327 3.60388C13.3854 3.67779 13.4335 3.75765 13.4764 3.84345C13.9703 4.83213 14.6048 6.20929 15.1233 7.69093C15.2609 8.08411 15.3915 8.48819 15.5097 8.89729ZM10.6672 3.60389C7.78042 4.05849 5.37633 5.96619 4.22726 8.55462C4.77258 8.60697 5.49681 8.67326 6.31177 8.73953C6.99426 8.79503 7.7373 8.85026 8.49028 8.8973C8.60841 8.48819 8.73909 8.08411 8.87667 7.69093C9.39511 6.20929 10.0297 4.83213 10.5236 3.84345C10.5664 3.75766 10.6146 3.6778 10.6672 3.60389ZM10.0311 8.9797C10.1127 8.71503 10.2002 8.45003 10.2925 8.18634C10.7829 6.78472 11.3883 5.46885 11.8654 4.51383C11.8894 4.46594 11.9155 4.44383 11.9337 4.43269C11.9539 4.42036 11.9767 4.41411 12 4.41411C12.0233 4.41411 12.0461 4.42036 12.0662 4.43269C12.0845 4.44384 12.1106 4.46594 12.1345 4.51383C12.6116 5.46885 13.217 6.78472 13.7075 8.18634C13.7997 8.45003 13.8873 8.71503 13.9689 8.9797C13.2777 9.00961 12.6078 9.02776 12 9.02776C11.3921 9.02776 10.7223 9.00962 10.0311 8.9797ZM8.12979 10.3774C7.45509 10.3334 6.7965 10.2839 6.19019 10.2346C5.29177 10.1615 4.5028 10.0885 3.9383 10.0337L3.73335 10.0136C3.58079 10.6509 3.5 11.316 3.5 12C3.5 12.7222 3.59007 13.4234 3.7596 14.0929C3.85578 14.102 3.96273 14.1119 4.07939 14.1226C4.63822 14.1739 5.4195 14.2423 6.30876 14.3107C6.88505 14.355 7.5046 14.3991 8.13693 14.4385C7.98871 13.7206 7.90526 12.9862 7.91791 12.2564C7.92843 11.6493 8.00602 11.0157 8.12979 10.3774ZM8.54954 15.966C7.73075 15.9189 6.92441 15.8624 6.19379 15.8062C5.48198 15.7515 4.83887 15.6968 4.3217 15.6507C5.50899 18.1434 7.87438 19.9668 10.6978 20.4009C10.672 20.3657 10.6472 20.3291 10.6236 20.2911C10.0182 19.3204 9.13993 17.7523 8.54954 15.966ZM13.3021 20.4009C16.1256 19.9668 18.491 18.1434 19.6783 15.6507C19.1611 15.6968 18.518 15.7515 17.8061 15.8062C17.0755 15.8624 16.2692 15.9189 15.4504 15.966C14.86 17.7523 13.9818 19.3204 13.3764 20.2911C13.3527 20.3291 13.3279 20.3657 13.3021 20.4009ZM13.8325 16.0444C13.1929 16.0687 12.5715 16.0833 12 16.0833C11.4284 16.0833 10.8071 16.0687 10.1674 16.0444C10.6832 17.4186 11.3677 18.6497 11.8963 19.4974C11.9178 19.5318 11.9388 19.5477 11.953 19.5555C11.9684 19.564 11.9844 19.5678 12 19.5678C12.0156 19.5678 12.0315 19.564 12.0469 19.5555C12.0611 19.5477 12.0821 19.5318 12.1036 19.4974C12.6323 18.6497 13.3167 17.4185 13.8325 16.0444ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              fill="#F5F4FF"
            />
          </svg>
          Share
        </button>
      </div>
    </div>
  );
};

export default CanvasHeader;
